import { render, staticRenderFns } from "./saveMember.vue?vue&type=template&id=78063b4d"
import script from "./saveMember.vue?vue&type=script&lang=js"
export * from "./saveMember.vue?vue&type=script&lang=js"
import style0 from "./saveMember.vue?vue&type=style&index=0&id=78063b4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports